// src/pages/projects/components/BudgetSummary.jsx
import React from 'react';
import { Grid, Card, CardContent, Typography } from '@mui/material';
import { formatCurrency } from '../../../utils/budgetUtils';

/**
 * Component to display the budget summary cards
 * @param {Object} props - Component props
 * @param {number} props.totalBudget - Total budget amount
 * @param {number} props.totalExpenses - Total expenses amount
 * @param {number} props.totalIncome - Total income amount
 * @param {number} props.remaining - Remaining budget amount
 * @returns {JSX.Element} Budget summary component
 */
const BudgetSummary = ({ totalBudget, totalExpenses, totalIncome, remaining }) => {
  return (
    <Grid container spacing={3} sx={{ mb: 3 }}>
      <Grid item xs={12} md={6} lg={3}>
        <Card>
          <CardContent>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Total Budget
            </Typography>
            <Typography variant="h4">
              {formatCurrency(totalBudget)}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      
      <Grid item xs={12} md={6} lg={3}>
        <Card>
          <CardContent>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Total Expenses
            </Typography>
            <Typography variant="h4" color="error.main">
              {formatCurrency(totalExpenses)}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      
      <Grid item xs={12} md={6} lg={3}>
        <Card>
          <CardContent>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Total Income
            </Typography>
            <Typography variant="h4" color="success.main">
              {formatCurrency(totalIncome)}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      
      <Grid item xs={12} md={6} lg={3}>
        <Card>
          <CardContent>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
              Remaining Budget
            </Typography>
            <Typography 
              variant="h4" 
              color={remaining < 0 ? 'error.main' : 'success.main'}
            >
              {formatCurrency(remaining)}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default BudgetSummary;